export const CAMBIAR_EQUIPO = 'CAMBIAR_EQUIPO';
export const AGREGAR_TITULAR = 'AGREGAR_TITULAR';
export const QUITAR_TITULAR = 'QUITAR_TITULAR';